/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable max-lines */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';

import LoaderV2 from 'Component/LoaderV2';
import Overlay from 'Component/Overlay';
import SearchItem from 'Component/SearchItem';
// eslint-disable-next-line max-len
import { SearchOverlay as SourceSearchOverlayComponent } from 'SourceComponent/SearchOverlay/SearchOverlay.component';
import { ItemsType } from 'Type/ProductList';
import history from 'Util/History';
import { formatPrice } from 'Util/Price';

import { removeHTML } from '../../util/Custom/removeHtml';
// import Loader from '../Loader';
import { AMOUNT_OF_PLACEHOLDERS, SEARCH_TIMEOUT } from './SearchOverlay.config';

import './SearchOverlay.style';

/** @namespace Mspwa/Component/SearchOverlay/Component/SearchOverlayComponent */
export class SearchOverlayComponent extends SourceSearchOverlayComponent {
    static propTypes = {
        searchCriteria: PropTypes.string,
        searchResults: ItemsType.isRequired,
        isLoading: PropTypes.bool.isRequired,
        makeSearchRequest: PropTypes.func.isRequired,
        clearSearchResults: PropTypes.func.isRequired,
        isHideOverlay: PropTypes.bool
    };

    static defaultProps = {
        searchCriteria: '',
        isHideOverlay: false
    };

    formatProductUrl(url) {
        if (!url) {
            return '';
        }

        return url.replace('/needtochange', '');
    }

    componentDidUpdate(prevProps) {
        const { searchCriteria: prevSearchCriteria } = prevProps;
        const { searchCriteria, clearSearchResults, makeSearchRequest } = this.props;

        if (searchCriteria !== prevSearchCriteria) {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            clearSearchResults();
            this.timeout = setTimeout(() => {
                this.timeout = null;
                makeSearchRequest();
            }, SEARCH_TIMEOUT);
        }
    }

    renderSearchItem(product, i) {
        return <SearchItem product={ product } key={ i } />;
    }

    renderSearchCriteria() {
        const { searchCriteria } = this.props;

        return (
            <p
                block="SearchOverlay"
                elem="Criteria"
                mods={ { isVisible: !!searchCriteria.trim() } }
            >
                { __('Results for:') }
                <strong>{ searchCriteria }</strong>
            </p>
        );
    }

    renderNoSearchCriteria() {
        return <p>{ __('Start typing to see search results!') }</p>;
    }

    renderNoResults() {
        return <p>{ __('No results found!') }</p>;
    }

    renderSearchResults() {
        const { searchCriteria, searchResults, isLoading } = this.props;

        if (!searchCriteria.trim()) {
            return this.renderNoSearchCriteria();
        }

        if (!searchResults.length && !isLoading && !this.timeout) {
            return this.renderNoResults();
        }

        const resultsToRender = isLoading || this.timeout
            ? Array(AMOUNT_OF_PLACEHOLDERS).fill({})
            : searchResults;

        return (
            <ul>
                { resultsToRender.map((item, i) => this.renderSearchItem(item, i)) }
            </ul>
        );
    }

    renderKlevuSearchResults() {
        // eslint-disable-next-line no-unused-vars
        const { klevuSearchResult, klevuLoading, onSearchBarChange } = this.props;

        if (klevuLoading) {
            return (
                <div className="KlevuLoading">
                    <LoaderV2 isLoading={ klevuLoading } />
                </div>
            );
        }
        const { queryResults = [], suggestionResults = [] } = klevuSearchResult;
        const firstSuggestions = suggestionResults.length > 0
            ? suggestionResults[0].suggestions
            : [];
        const productSearch = queryResults[0] || {};
        const categorySearch = queryResults[1] || {};

        if (Object.keys(klevuSearchResult).length === 0) {
            return (
                <div className="noSearchResult">
                    Start typing to see search results!
                </div>
            );
        }

        if (
            firstSuggestions.length === 0
            && categorySearch.records?.length === 0
            && productSearch.records?.length === 0
        ) {
            return <div className="noSearchResult">No results found</div>;
        }

        return (
            <div className="Resultmain">
                { firstSuggestions.length > 0 && (
                    <div className="MedSuggestion">
                        <div className="Medtitle"> Suggestions </div>
                        <ul>
                            { firstSuggestions.map(({ suggest }, i) => (
                                <li key={ i }>
                                    <a
                                        onClick={ () => history.push(
                                            `/search/${removeHTML(suggest)}`
                                        ) }
                                    >
                                        { removeHTML(suggest) }
                                    </a>
                                </li>
                            )) }
                        </ul>
                    </div>
                ) }
                { categorySearch.records?.length > 0 && (
                    <div className="MedCategory">
                        <div className="Medtitle">Category</div>
                        <ul>
                            { categorySearch.records.map((prod) => (
                                <li key={ prod.id }>
                                    <a href={ prod.url }>{ prod.name }</a>
                                </li>
                            )) }
                        </ul>
                    </div>
                ) }

                { productSearch.records?.length > 0 && (
                    <div className="MedProducts">
                        <div className="Medtitle"> Products </div>
                        <div className="MedView">
                            <a href="#">View all</a>
                        </div>
                        <ul>
                            { productSearch.records.map((product) => (
                                <li key={ product.id }>
                                    <a href={ product.url }>
                                        <div className="ProductImg">
                                            <img
                                                src={ this.formatProductUrl(
                                                    product.image
                                                ) }
                                            />
                                        </div>
                                        <div className="ProductDesc">
                                            <div className="ProductTitle">
                                                <h4>{ product.name }</h4>
                                            </div>
                                            <div className="ShortDesc">
                                                { removeHTML(product.shortDesc) }
                                            </div>
                                            <div className="SalePrice">
                                                <span>
                                                    { formatPrice(
                                                        product.salePrice,
                                                        'AED'
                                                    ) }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="clearfix"> </div>
                                    </a>
                                </li>
                            )) }

                            <div className="clearfix"> </div>
                        </ul>
                    </div>
                ) }
            </div>
        );
    }

    render() {
        const { isKlevuSearch } = this.props;

        //   if (false) {
        //       return (
        //     <article
        //       block="SearchOverlay"
        //       elem="Results"
        //       aria-label="Search results"
        //     >
        //       { this.renderSearchResults() }
        //     </article>
        //       );
        //   }

        if (isKlevuSearch) {
            return (
                <Overlay id="search" mix={ { block: 'SearchOverlay' } }>
                    { this.renderSearchCriteria() }
                    <article
                        block="SearchOverlay"
                        elem="Results"
                        aria-label="Search results"
                    >
                        { this.renderKlevuSearchResults() }
                    </article>
                </Overlay>
            );
        }

        return (
            <Overlay id="search" mix={ { block: 'SearchOverlay' } }>
                { this.renderSearchCriteria() }
                <article
                    block="SearchOverlay"
                    elem="Results"
                    aria-label="Search results"
                >
                    { this.renderSearchResults() }
                </article>
            </Overlay>
        );
    }
}

export default SearchOverlayComponent;
